import useMiddlewareContext from './hooks/useMiddlewareContext';

export default () => {
  const { store } = useMiddlewareContext();

  // Skip for leads - they're not customers yet
  if (store.state.current_user._company?.status === 'lead') {
    return;
  }

  if (store.state.current_user.role !== 'user') {
    return;
  }

  if (store.state.current_user._auth.TOSAccepted) {
    return;
  }

  if (store.state.showedTermsOfService) {
    return;
  }

  // eslint-disable-next-line consistent-return
  return store.commit('showTermsOfService', true);
};
